import React, { useState } from 'react'
import Modal from '@material-ui/core/Modal'
import styled from 'styled-components'
import * as Colors from '../../constants/colors'
import { ILiveWorkout, LiveConfig } from '../../types'
import PaymentForm from '../Payment/PaymentForm'
import { SubscriptionType } from '../../services/fetch/payments'
import { SUBSCRIPTION_OUTLINE, SUBSCRIPTION_FILL } from '../../constants/colors'
import * as M from '../../styles/modal.styles'
import * as I from '../../components/shared/Icons'
import { navigate } from 'gatsby'
import Loader from 'react-loader-spinner'
import ModalReact from 'react-modal'
import {
  BASIC_LIVE_SCHEDULE,
  LOGIN_ROUTE,
  WORKOUTS_ROUTE,
} from '../../constants/routes'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import * as S from '../../styles/index.styles'

const top = 50
const left = 50

export const Body = styled.div`
  position: absolute;
  width: 435px;
  padding: 40px;
  padding-top: 15px;
  overflow: scroll;
  top: ${`${top}%`};
  left: ${`${left}%`};
  transform: ${`translate(-${top}%, -${left}%)`};
  background: white;
  outline: none;
  border-radius: 4px;
  background: ${Colors.themeColors.pageBg};
  color: ${Colors.themeColors.textColor};
  display: flex;
  justify-content: center;
  flex-direction: column;
  overflow: scroll;
  border: 1px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
    0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
`

export const Title = styled.div`
  font-size: 22px;
  margin-bottom: 5px;
`

export const Date = styled.div`
  margin-bottom: 40px;
`

export const Wrap = styled.div`
  width: 350px;
  margin-right: 80px;
`

export const Subscriptions = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 50px;
`

export const IconWrap = styled.div`
  width: 100%;
  margin-left: -15px;
`

export const SubscriptionContainer = styled.div<{
  isSelected: boolean
}>`
  margin-right: 22px;
  margin-bottom: 20px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  border: 2px solid
    ${({ isSelected }) =>
      isSelected ? SUBSCRIPTION_FILL : SUBSCRIPTION_OUTLINE};
  border-radius: 15px;
  width: 100%;
  padding: 20px 16px;
  background-color: ${({ isSelected }) =>
    isSelected ? SUBSCRIPTION_FILL : 'transparent'};
`

const customStyles = {
  overlay: {
    zIndex: 100000,
    backgroundColor: 'rgba(0,0,0,0.3)',
  },
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: 'transparent',
    border: '0px solid transparent',
  },
}

interface Props {
  open: boolean
  handleClose: () => void
  workout: ILiveWorkout
  liveConfig: LiveConfig
}

const PurchaseModal = ({ open, handleClose, workout, liveConfig }: Props) => {
  const [isLoadingPayment, setIsLoadingPayment] = useState(false)
  const [errorInPayment, setErrorInPayment] = useState(false)
  const [error, setError] = useState(null)

  const priceIdSelected = workout.priceId

  const { amount, currency } =
    workout.isForSale &&
    liveConfig &&
    liveConfig.liveWorkoutPrices.find(
      price => price.priceId === workout.priceId,
    )

  const subscriptionType = SubscriptionType.monthly

  const paymentSuccessful = () => {
    setIsLoadingPayment(false)
    handleClose()
    window.location.reload()
    triggerAnalytics()
  }

  const onCloseModalLoader = () => {
    if (!isLoadingPayment && !errorInPayment) {
      navigate(BASIC_LIVE_SCHEDULE)
    }

    setIsLoadingPayment(false)
  }

  const paymentUnsuccessful = (errorText: string) => {
    setError(errorText)
    setIsLoadingPayment(false)
    setErrorInPayment(true)
  }

  const triggerAnalytics = () => {
    typeof (window as any).MyNamespace !== 'undefined' &&
      (window as any).MyNamespace.gtag('Purchases', 'click') &&
      (window as any).MyNamespace.gtag('event', 'conversion', {
        value: amount,
        currency: currency,
      })
  }

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
    >
      <Body>
        <IconWrap>
          <S.SubscriptionSecondary>
            <IconButton onClick={handleClose}>
              <CloseIcon style={{ color: Colors.themeColors.textColor }} />
            </IconButton>{' '}
            Already have an account?{' '}
            <span
              onClick={() => navigate(LOGIN_ROUTE)}
              style={{
                color: Colors.DARK_BLUE,
                cursor: 'pointer',
              }}
            >
              Log in
            </span>
          </S.SubscriptionSecondary>
        </IconWrap>
        <PaymentForm
          key={priceIdSelected}
          isVisible={!!priceIdSelected}
          handleModal={() => setIsLoadingPayment(true)}
          paymentSuccessful={paymentSuccessful}
          paymentUnsuccessful={paymentUnsuccessful}
          workout={workout}
          isPurchase={true}
          hideNewsletter={true}
          liveClass={{
            amount,
            currency,
            priceId: priceIdSelected,
            subscriptionType,
          }}
        />
        <ModalReact
          ariaHideApp={false}
          isOpen={isLoadingPayment}
          onRequestClose={onCloseModalLoader}
          style={customStyles}
        >
          <M.Container>
            <M.Wrap>
              {isLoadingPayment ? (
                <>
                  <Loader
                    type="ThreeDots"
                    color="#14213d"
                    height={30}
                    width={30}
                  />
                  <M.Primary>Purchasing the class . . .</M.Primary>
                  <M.Secondary>Please wait a few minutes!</M.Secondary>
                </>
              ) : errorInPayment ? (
                <>
                  <M.Primary>An error occurred.</M.Primary>
                  <M.Secondary>{error}</M.Secondary>
                </>
              ) : (
                <>
                  <I.CircleCheck color={'green'} />
                  <M.Primary>
                    Congrats, you&apos;ve successfully purchased a class!
                  </M.Primary>
                  <M.Secondary>Get started on your journey!</M.Secondary>
                </>
              )}
            </M.Wrap>
            {!isLoadingPayment && !errorInPayment && (
              <M.LoginButton onClick={() => navigate(WORKOUTS_ROUTE)}>
                <M.LoginText>Continue to explore workouts</M.LoginText>
              </M.LoginButton>
            )}
          </M.Container>
        </ModalReact>
      </Body>
    </Modal>
  )
}

export default PurchaseModal
